export default __webpack_public_path__ + "static/ultraPlayBannerImg-0f9a95cce02a4e2b1c83c464a79ade4f.png";